export default [
  {
    id: 'DEV716627',
    title: 'Se agrego nuevo Monitoreo: \n\n SITIO WEB [CHILE]',
    when: '2019-10-15 15:35:01',
    type: 'feature',
    to: '/orders/DEV730658'
  },
  {
    id: 'DEV853890',
    title: 'Se agrego nuevo usuario ',
    when: '2019-10-14 20:04:01',
    type: 'user',
    to: '/users/DEV696649'
  },
  {
    id: 'DEV897704',
    title: 'Se Creo un Nuevo Horario Hábil',
    when: '2019-10-14 16:32:01',
    type: 'product',
    to: '/products/DEV654476'
  },
  {
    id: 'DEV604714',
    title: 'Se cambio configuración de Objetivo: \n\n REPORTE2 [COLOMBIA]',
    when: '2019-10-12 16:00:00',
    type: 'feature',
    to: '/features'
  }
];
